import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import formatPrice from '../../../util/formatPrice';
import { labelsPropTypes, paymentLoadPropTypes } from './PropTypes';

import { withErrorBoundary } from '../Core/ErrorBoundary';
import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../../util/currency';

const propTypes = exact({
  apiURL: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  data: paymentLoadPropTypes,
  isBooking: PropTypes.bool,
  labels: labelsPropTypes,
  cleanup: PropTypes.func.isRequired,
});

const defaultProps = {
  data: undefined,
  isBooking: false,
  labels: undefined,
};

class BookingPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingTime: null,
    };
  }

  componentDidMount() {
    this.checkIfStScriptIsLoaded();
  }

  componentWillUnmount() {
    if (this.checkScript) clearInterval(this.checkScript);
    if (this.countdown) clearInterval(this.countdown);
    if (this.props.cleanup) this.props.cleanup();
  }

  checkIfStScriptIsLoaded() {
    this.checkScript = setInterval(() => {
      if (window.SecureTrading) {
        const st = window.SecureTrading({
          jwt: this.props.data.jwt,
          livestatus: this.props.labels.liveMode ? 1 : 0,
          submitOnSuccess: true,
          animatedCard: true,
          submitOnError: false,
        });

        st.Components();

        clearInterval(this.checkScript);

        this.startCountdown();
      }
    }, 500);
  }

  startCountdown() {
    const minutesLimit = 15;
    const duration = moment.duration(minutesLimit, 'minutes');

    this.countdown = setInterval(() => {
      const milliseconds = duration.subtract(1, 'seconds').asMilliseconds();

      this.setState({ remainingTime: milliseconds });

      if (milliseconds === 0) {
        clearInterval(this.countdown);
      }
    }, 1000);
  }

  render() {
    const { submitUrl, currencySymbol, data, isBooking, labels } = this.props;
    const { remainingTime } = this.state;

    return (
      <div
        className={classNames('PaymentForm', {
          Booking: isBooking,
        })}
      >
        <div className="PaymentForm_label">
          <strong>{labels.transactionAmountLabel}:</strong>
          &nbsp;{currencySymbol || DEFAULT_CRITICAL_BACKUP_CURRENCY.symbol}
          {formatPrice(data.price)}
        </div>
        <div className="PaymentForm_label">
          <strong>{labels.transactionReferenceLabel}:</strong>
          &nbsp;{data.transactionReference}
        </div>
        <div className="PaymentForm_label">
          <strong>{labels.expiresText}</strong>
        </div>
        <div
          id="timeLabel"
          className={`PaymentForm_label PaymentForm_label-time${
            remainingTime != null ? ' visible' : ''
          }`}
        >
          {labels.expiresLabel.replace('{minutes}', moment(remainingTime).format('mm:ss'))}
        </div>
        <div
          id="time"
          className={`PaymentForm_label PaymentForm_label-expiredMessage${
            remainingTime === 0 ? ' visible' : ''
          }`}
        >
          {labels.expiredLabel}
        </div>

        <div id="st-notification-frame" />
        <form id="st-form" action={submitUrl} method="post">
          <div id="st-card-number" className="st-card-number" />
          <div id="st-expiration-date" className="st-expiration-date" />
          <div id="st-security-code" className="st-security-code" />
          <button
            type="submit"
            id="st-form__submit"
            disabled={remainingTime === 0}
            className={`st-form__submit${remainingTime === 0 ? ' disabled' : ''}`}
          >
            {labels.submitButtonText}
          </button>
          <div id="st-animated-card" className="st-animated-card-wrapper" />
        </form>
      </div>
    );
  }
}

BookingPayment.propTypes = propTypes;
BookingPayment.defaultProps = defaultProps;

export default withErrorBoundary(BookingPayment);
